import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from './data.service';
import { Entity, Plan } from '../model/entity';
import { AliquotTax } from '../model/aliquot-tax';

@Injectable()
export class EntityService {

  constructor(private http: HttpClient, private dataService: DataService) { }

  private readonly getEntitiesByNameEndPoint: string = '/entity/getEntitiesByName/';
  private readonly getEntitiesEndPoint: string = '/entity/getEntities/';
  private readonly getPlansByEntityIdEndPoint: string = '/entity/getPlansByEntityId/';
  private readonly getPlansByEntityIdsEndPoint: string = '/entity/getPlansByEntityIds/';
  private readonly getEntityPreAuthorizeInReservationEndPoint: string = '/entity/getEntityPreAuthorizeInReservation/';

  getEntitiesByName(name: string): Observable<Entity[]> {
    const params = { name: name };
    return this.dataService.get<Entity[]>(this.getEntitiesByNameEndPoint, params);
  }

  getEntityPreAuthorizeInReservation(entityId: number): Promise<boolean> {
    const params = { entityId: entityId };
    return this.dataService.get<boolean>(this.getEntityPreAuthorizeInReservationEndPoint, params).toPromise();
  }

  async getEntities(excludeDerivantes: boolean = false): Promise<Entity[]> {
    const params = { excludeDerivantes };
    return await this.dataService.get<Entity[]>(this.getEntitiesEndPoint, params).toPromise();
  }

  async getPlansByEntityId(entityId: number): Promise<Plan[]> {
    const params = { entityId: entityId };
    return await this.dataService.get<Plan[]>(this.getPlansByEntityIdEndPoint, params).toPromise();
  }

  async getPlansByEntityIds(entityIds: number[]): Promise<Plan[]> {
    const params = { entityIds: JSON.stringify(entityIds) };
    return await this.dataService.get<Plan[]>(this.getPlansByEntityIdsEndPoint, params).toPromise();
  }

}
